export default __webpack_public_path__ + "static/about-us-page-banner-5fc93b4b12e6ba5c8f9f8ff1e3a3545b.jpg";